export function stringToDate(string) {
    var dateFull = string.split(" ");
    var date = dateFull[0].split("-");
    var time = dateFull[1].split(":");

    var second = parseInt(time[2]);
    var minute = parseInt(time[1]);
    var hour = parseInt(time[0]);
    var day = parseInt(date[2]);
    var month = parseInt(date[1] - 1);
    var year = parseInt(date[0]);

    return new Date(year, month, day, hour, minute, second, 0);
}